import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Confirm } from 'semantic-ui-react'

import { MainBodyContent, StatusTag } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { 
  bgCompanyRequestPath,
  bgCompanyRequestEditPath
} from 'routes'
import { 
  getBGCompanyRequestDetail,
  getBGCRFlowDetail,
  actionBGCompanyRequest,
} from 'ducks/bgCompanyRequest'
import { 
  getListDocForExtend,
} from 'ducks/bgCompany'
import { statusColor } from '../AttributeData'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { validateApproveField } from '../helper'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import RequestForComponent from '../Shareds/RequestFor'
import BankGuaranteeInformation from '../Shareds/BankGuaranteeInformation'
import GeneralInformation from '../Shareds/GeneralInformation'
import ContactComponent from '../Shareds/Contact'
import AttachmentComponent from '../Shareds/Attachment'
import CommentComponent from '../Shareds/Comment'
import Approve from '../Shareds/Approve'
import ReceiveInformation from '../Shareds/ReceiveInformation'
import BankGuaranteeRelated from '../Shareds/BankGuaranteeRelated'
import r from 'reactotron-react-js'

const DetailBankGuaranteeCompanyRequest = (props) => {

  const { 
    valueForm, 
    username,
    history,
    isDetail = true
  } = props

  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(()=>{ // check to edit mode
    if(valueForm.id){
      if([0,500].indexOf(valueForm.status)>=0){
        if(username == valueForm.createdBy){
          history.replace(bgCompanyRequestEditPath(valueForm.id))
        }
      }
    }
  },[valueForm.id])

  React.useEffect(() => {
    props.getBGCompanyRequestDetail(props.match.params.id, props.history)
    props.getBGCRFlowDetail(props.match.params.id)
    props.getVendors()
    props.getCompanies()
    props.getCustomers()
    props.getListDocForExtend()
  }, [])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const confirmSubmit = () =>{
    setShowConfirm(false)
    props.actionBGCompanyRequest(
      {
        docId:valueForm.id,
        sn:valueForm.sn,
        action:valueForm.actionKey,
        comment:valueForm.comment,
        appointmentReceiveDate:valueForm.appointmentReceiveDate,
        receiveDate:valueForm.receiveDate,
        BGC03:valueForm.bgc03
      },
      props.history
    )
  }

  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Request Bank Guarantee - ${valueForm.documentNumber||'Detail'}`}
          <StatusTag status={valueForm.status} statusName={valueForm.statusName} style={{background:statusColor[`${valueForm.status}`],marginLeft: '10px'}}/>
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'BG Company - Request New/Extend', link: true, onClick: () => props.history.push(bgCompanyRequestPath) },
              { key: 'BGDetail', content: 'Detail', active: true }
            ]
          }
        />
      }
    >
      <DocumentStep documentDetail={valueForm} approvers={props.flowDetail} />
      <RequestForComponent/>
      {valueForm.requestType?
        <React.Fragment>
          <BankGuaranteeInformation/>
          <GeneralInformation isDetail={isDetail}/>
          <ContactComponent/>
          {valueForm.referenceBgCompanyId?
          <BankGuaranteeRelated/>:null}
          <AttachmentComponent isDetail/>
          {valueForm.appointmentReceiveDate||valueForm.status==202?
          <ReceiveInformation/>:null}
          <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
            <Approve/>
          </form>
          <CommentComponent/>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => confirmSubmit()}
          />
        </React.Fragment>:null
      }
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const valueForm = getFormValues('formBGCompanyRequest')(state) || {}

  return ({
    valueForm,
    username,
    flowDetail:state.bgCompanyRequest.flowDetail.data,
    initialValues: {
      requesterUser: username,
      attachments: [],
      contacts: [],
      comments: [],
      isContactValid: true,
      ...state.bgCompanyRequest.detail.data
    },
  })
}

const mapDispatchToProps = {
  getBGCompanyRequestDetail,
  getBGCRFlowDetail,
  actionBGCompanyRequest,
  getVendors, 
  getCompanies,
  getListDocForExtend,
  getCustomers
}

const validate = (values) => {
  let errors = validateApproveField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGCompanyRequest',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate
})(DetailBankGuaranteeCompanyRequest)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
